import { RenderNullComponent } from '../lib/tools'

export default class NotFound extends RenderNullComponent {
  UNSAFE_componentWillMount() { window.location.replace('/404') }
}
